import { axiosClient } from './axiosClient';
import type { ApiResponse } from '../types/api.types';

export type CustomizationConfig = {
  modules: Record<string, boolean>;
  sections: Record<string, boolean>;
  dashboard_widgets: string[];
};

export type WidgetDescriptor = {
  id: string;
  label: string;
  allowed_roles: string[];
};

export type ModuleToggle = {
  key: string;
  label: string;
  description: string;
  enabled: boolean;
};

export type SectionToggle = {
  key: string;
  label: string;
  description: string;
  visible: boolean;
};

export type CustomizationOverview = {
  widgets: WidgetDescriptor[];
  layouts: Record<string, string[]>;
  modules: ModuleToggle[];
  sections: SectionToggle[];
};

export const customizationApi = {
  me: () => axiosClient.get<ApiResponse<CustomizationConfig>>('/customization/me').then((r) => r.data),
};

export const adminCustomizationApi = {
  overview: () =>
    axiosClient.get<ApiResponse<CustomizationOverview>>('/admin/customization/overview').then((r) => r.data),
  updateLayout: (role: string, widgets: string[]) =>
    axiosClient
      .put<ApiResponse<{ role: string; widgets: string[] }>>(
        `/admin/customization/dashboards/${role}`,
        { widgets },
      )
      .then((r) => r.data),
  toggleModule: (key: string, enabled: boolean) =>
    axiosClient
      .put<ApiResponse<{ key: string; enabled: boolean }>>(
        `/admin/customization/modules/${key}`,
        { enabled },
      )
      .then((r) => r.data),
  toggleSection: (key: string, visible: boolean) =>
    axiosClient
      .put<ApiResponse<{ key: string; visible: boolean }>>(
        `/admin/customization/sections/${key}`,
        { visible },
      )
      .then((r) => r.data),
};
